import ThemeEditor from './ThemeEditor';

export default ThemeEditor;
